export const hideHeroStrip = ref(false);

export function useControlHeroStrip(state: boolean) {
    hideHeroStrip.value = state;
    return hideHeroStrip;
}
